<template>
  <div class="ticket-list-page">
    <div class="content-box">
      <div class="box1 flex-row row-between col-center">
        <van-dropdown-menu>
          <van-dropdown-item v-model="search.city" :options="selectOption.option2"/>
        </van-dropdown-menu>
        <van-search
            v-model="search.keyword"
            placeholder="搜索景点或目的地"
            shape="round"
            style="width: 230px"
        />
        <div class="flex-row col-center">
          <van-icon name="location-o"/>
          <span style="font-size: 14px;color: #333333;">附近周边</span>
        </div>
      </div>
      <div class="box2">
        <van-dropdown-menu class="mt1">
          <van-dropdown-item v-model="selectOption.value1" :options="selectOption.option1"/>
          <van-dropdown-item v-model="selectOption.value2" :options="selectOption.option2"/>
          <van-dropdown-item v-model="selectOption.value3" :options="selectOption.option3"/>
          <van-dropdown-item v-model="selectOption.value4" :options="selectOption.option4" title="价格"/>
          <van-dropdown-item v-model="selectOption.value5" :options="selectOption.option5" title="更多"/>
        </van-dropdown-menu>
      </div>
      <div class="box3 mt10">
        <div v-for="item of goodsList" :key="item.id" class="goods-item-box mt6 flex-row">
          <img alt="" class="goods-img" src="images/test/03.jpeg">
          <div class="ml10">
            <div style="font-size: 15px;font-weight: 500;color: #333333;">{{ item.name }}</div>
            <div class="flex-row col-center mt6" style="font-size: 11px;color: #808080">
              <span style="color: #ECA805;margin-right: 4px">{{ item.score }}分</span>|
              <span style="margin: 0 4px">{{ item.stop_car ? '可停车' : '' }}</span>|
              <span style="margin-left: 4px">{{ item.has_wifi ? 'wifi' : '' }}</span>
            </div>
            <div class="mt6" style="font-size: 14px;color: #666666;">
              <span>{{ item.address }}</span>
            </div>
            <div class="mt6" style="font-size: 12px;color: #666666;">
              <span>营业时间：</span>
              <span>{{ item.open_time }}</span>
            </div>
            <div class="flex-row row-between mt6 " style="font-size: 15px;color: #808080">
              <div class="flex-row col-end">
                <div style="color: #F23A3A">
                  <span style="margin-right: 2px">{{ item.price2 }}</span>
                  <span style="font-size: 11px">起</span>
                </div>
                <div class="ml8" style="font-size: 11px;text-decoration: line-through;">￥{{ item.price1 }}</div>
              </div>
              <div class="flex-row col-end" style="font-size: 12px;margin-left: 20px">
                <div>
                  {{ item.appraise_num }}人评价
                </div>
                <div class="ml8">
                  {{ item.like }}好评
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      search: {
        city: 0,
        keyword: ''
      },
      selectOption: {
        value1: 0,
        value2: 0,
        value3: 0,
        value4: 0,
        value5: 0,
        option1: [
          {text: '综合', value: 0},
          {text: '销量', value: 1},
          {text: '好评', value: 2},
        ],
        option2: [
          {text: '成都', value: 0},
          {text: '德阳', value: 1},
          {text: '绵阳', value: 2},
        ],
        option3: [
          {text: '五星', value: 0},
          {text: '四星', value: 1},
          {text: '三星', value: 2},
        ],
        option4: [
          {text: '从高到低', value: 0},
          {text: '从低到高', value: 1}
        ],
        option5: [
          {text: '德阳', value: 0},
          {text: '绵阳', value: 1},
        ],
      },
      goodsList: [
        {
          id: 1,
          name: '麓湖水城',
          score: 4.8,
          address: '成都市天府新区天府大道',
          open_time: '4/10-7/31 10:00-22:00',
          price1: 200,
          price2: 148,
          appraise_num: 22154,
          like: '94%',
          stop_car: 1,
          has_wifi: 1
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "index";
</style>
